import React, { PropTypes } from 'react';


const propTypes = {
  location: PropTypes.object,
  children: PropTypes.any.isRequired,
};

const Home = ({ loading, children }) => {
  const result = loading
    ? <div className="ui active dimmer"><div className="ui big loader" /></div>
    : children
  ;

  return result;
};

Home.propTypes = propTypes;
export default Home;



/** WEBPACK FOOTER **
 ** ./src/app/modules/login/components/root/Root.js
 **/